import { render } from "./attract.vue?vue&type=template&id=75f115d9&scoped=true"
import script from "./attract.vue?vue&type=script&lang=js"
export * from "./attract.vue?vue&type=script&lang=js"

import "./attract.vue?vue&type=style&index=0&id=75f115d9&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\四个火体育_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75f115d9"]])

export default __exports__